// Definir el elemento personalizado para overlay-sidebar
class OverlaySidebar extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        // Aquí puedes añadir contenido o lógica si es necesario
    }

    show() {
        this.classList.add('show');
    }

    hide() {
        this.classList.remove('show');
    }
}

// Registrar el elemento personalizado
customElements.define('overlay-sidebar', OverlaySidebar);


class SidebarContent extends HTMLElement {
    constructor() {
        super();
        this.isVisible = false;

        // Crear el overlay dinámicamente usando el nuevo elemento personalizado
        this.overlay = document.createElement('overlay-sidebar');
        document.body.insertBefore(this.overlay, document.body.firstChild);

        // Crear el botón de cierre dinámicamente
        this.closeButton = document.createElement('sidebar-close');
        this.closeButton.textContent = '×';
        this.appendChild(this.closeButton);

        // Asociar el overlay con el sidebar actual
        this.overlay.addEventListener('click', () => this.hide());

        // Mover el sidebar al primer lugar
        this.move();
    }

    connectedCallback() {
        // Configurar el evento de clic del botón de cierre
        this.closeButton.addEventListener('click', () => this.hide());

        // Agregar el manejador de eventos para cerrar con la tecla ESC
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    disconnectedCallback() {
        // Limpiar el manejador de eventos cuando se desconecta el elemento
        document.removeEventListener('keydown', this.handleKeydown.bind(this));
    }

    move() {
        document.body.insertBefore(this, document.body.firstChild);
    }

    show() {
        if (!this.isVisible) {
            this.classList.add('show');
            this.isVisible = true;
            this.overlay.show();
        }
    }

    hide() {
        if (this.isVisible) {
            this.classList.remove('show');
            this.isVisible = false;
            this.overlay.hide();
        }
    }

    handleKeydown(event) {
        if (event.key === 'Escape') {
            this.hide();
        }
    }
}

// Definir el elemento personalizado para sidebar-trigger
class SidebarTrigger extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            const module = this.getAttribute('module');
            const sidebar = document.querySelector(`sidebar-content[module="${module}"]`);
            if (sidebar) {
                if (!sidebar.isVisible) {
                    sidebar.show();
                }
            }
        });
    }
}

// Definir el elemento personalizado para sidebar-close
class SidebarClose extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            const sidebar = this.closest('sidebar-content');
            if (sidebar) {
                sidebar.hide();
            }
        });
    }
}

// Registrar elementos personalizados
customElements.define('sidebar-content', SidebarContent);
customElements.define('sidebar-trigger', SidebarTrigger);
customElements.define('sidebar-close', SidebarClose);
